export default () => ({
    
    navigationInView: true,
    navigationOnTop: true,
    navigationOpen: false,

    init() {

        this.listenToScroll();
        
    },

    listenToScroll() {

        const self = this;
        let lastScrollTop = 0;

        window.addEventListener('scroll', function(){

            let st = window.pageYOffset;

            if(st < 0){

                return false;
            }

            if (st > lastScrollTop){
                        
                if((st - lastScrollTop) > 15)
                {
                    self.hideNav();
                }

            } else {

                if((lastScrollTop - st) > 10)
                {
                    self.showNav();
                }

            }

            if(st < 75){
        
                self.setTop();

            }else {

                self.unSetTop();
            }

            lastScrollTop = st;

        });

    },

    showNav() {

        this.navigationInView = true;
        
    },
    
    hideNav() {
        
        this.navigationInView = false;

    },

    setTop(){
        
        this.navigationOnTop = true;
   
    },
    
    unSetTop(){
        
        this.navigationOnTop = false;
        
    }

})